module.exports = __webpack_public_path__ + "static/media/alphaTetris-gameplay.8b1251b2.png";